"use client";
import PhoneInput from "react-phone-input-2";
import "./VePhone.scss";
import "react-phone-input-2/lib/material.css";
import { VeBox, VeTypography, makeStyles } from "../../mui";

interface PhoneTypes {
  onChange?: any;
  name?: string;
  sx?: any;
  error?: boolean;
  register?: any;
  label?: string;
  value?: string;
  onBlur?: any;
  disabled?: boolean;
  countryCode?: any;
  errorText?: string;
  position?: boolean;
  blockedCountries?: string;
}

const useStyles = makeStyles({
  phoneInputContainer: {
    "& .react-tel-input .country-list": {
      position: "fixed !important",
    },
    "& .react-tel-input .country-list .flag": {
      top: "-3px !important",
    },
  },
});

export function VePhone({
  onChange = () => {},
  name = "",
  register,
  sx,
  label,
  value,
  onBlur,
  disabled,
  countryCode,
  error,
  errorText,
  position = false,
  blockedCountries = "",
}: PhoneTypes) {
  const classes = useStyles();

  const excludedCountries =
    blockedCountries?.length > 0
      ? blockedCountries.split(",")?.map((item: string) => item.toLowerCase())
      : [];

  return (
    <div
      className={`${position && classes.phoneInputContainer} phone-container`}
    >
      <VeBox height={"40px"}>
        <PhoneInput
          excludeCountries={[...excludedCountries]}
          country={countryCode ? countryCode : "us"}
          enableSearch
          value={value}
          {...(register && register(name))}
          className={error && "phone-invalid "}
          onChange={(data, country) => {
            onChange({ data, country, name });
          }}
          autoFormat={false}
          onBlur={onBlur}
          specialLabel={label}
          inputProps={{
            name,
            required: true,
          }}
          placeholder="Phone Number"
          countryCodeEditable={false}
          disabled={disabled}
          containerStyle={{ paddingBottom: 0, borderRadius: "4px" }}
        />
      </VeBox>
      {error && errorText && (
        <VeBox sx={{ lineHeight: "0px", marginTop: "3px" }}>
          <VeTypography
            style={{ marginLeft: "10px" }}
            variant="label4ErrorPrimary"
          >
            {errorText}
          </VeTypography>
        </VeBox>
      )}
    </div>
  );
}
